module.exports = __webpack_public_path__ + "img/Unidad9-4.b8fbfb6e.png";